/* eslint-disable no-undef */
/**
 * File: locationOverviewMap.js.
 *
 * Import and initialize functions for Location Overview Google Maps
 */

export default {
  locations: document.querySelector('[js-locations]'),
  locationsMapContainer: document.querySelector('[js-location-overview-map]'),

  prevInfoWindow: false,
  init() {
    if (this.locations) {
      this.render();
    }
  },
  setMarker(location, map) {
    const marker = new google.maps.Marker({
      map,
      place: {
        placeId: location.place_id,
        location: {
          lat: location.lat,
          lng: location.lng
        }
      },
      title: location.title
    });

    //  info window content
    const contentString = `
      <h4>${location.title}</h4>
      <div class="popup">
        <div style="width: 200px">
         <p>${location.address}</p>
        </div>
        <a aria-label="Get directions to this location on Google Maps." target="_blank" jstcache="38" href="https://www.google.com/maps/dir/?api=1&destination=${location.address}&destination_place_id=${location.place_id}" class="navigate-link"> <div class="icon navigate-icon"></div> <div jstcache="39" class="navigate-text">Directions</div> </a>
      </div>
    `;

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
    });

    marker.addListener("click", () => {
      if (this.prevInfoWindow) {
        this.prevInfoWindow.close();
      }
      this.prevInfoWindow = infowindow;
      infowindow.open({
        anchor: marker,
        map,
        shouldFocus: true,
      });
    });

  },
  async renderMap() {
    const locationsMapContainer = this.locationsMapContainer;
    locationsMapContainer.style.height = '503px';
    let map;

    // initialize the map
    map = new google.maps.Map(locationsMapContainer, {
      zoom: 7,
    });

    // hides other points of interest
    map.setOptions({
      styles: [
        {
          featureType: "poi",
          stylers: [{ visibility: "off" }],
        }
      ]
    });


    const locations = this.locations.querySelectorAll('li');
    // creates markers and bounds
    const bounds = new google.maps.LatLngBounds();

    locations.forEach(location => {
      const {lat, lng, placeid, address} = location.dataset;
      const position = new google.maps.LatLng(lat, lng)
      bounds.extend(position);
      this.setMarker({
        lat: parseFloat(lat),
        lng: parseFloat(lng),
        place_id: placeid,
        title: location.innerHTML,
        address
      }, map);
    })

    map.fitBounds(bounds);
  },
  render() {
    this.renderMap();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
